import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os cadastros
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} co_ubs
 */
export async function getDados(cod_ibge, co_ubs, mes, ano) {
  try {
    const producao = await api.get(
      `/app/v2/ceo/${cod_ibge}/producao/${co_ubs}/${mes}-${ano}`
    )
    const meta = await api.get(
      `/app/v2/ceo/${cod_ibge}/meta/${co_ubs}/${mes}-${ano}`
    )
    const professional = await api.get(
      `/app/v2/ceo/${cod_ibge}/meta-por-profissional/${co_ubs}/${mes}-${ano}`
    )
    return {
      producao: producao.data,
      meta: meta.data.map((item) => {
        return { ...item, color: true }
      }),
      professional: professional.data,
    }
  } catch (err) {
    console.log(err)
  }
}

export function generatePdf(cadastros, no_us, mes, ano, typeCeo, typeTable) {
  let title_pdf = 'CEO'
  let titlePdfSave = utils.methods.titlePdf('CEO', '')
  let description_pdf = 'Atendimentos realizados e metas por competência'
  let headers_pdf = []
  if (typeTable === 'producao') {
    headers_pdf = ['SEQUÊNCIA', 'PROCEDIMENTO', 'CBO', 'QUANTIDADE']
    var data_pdf = []
    for (let i = 0; i < cadastros.length; i++) {
      var obj = {}
      obj.sequencia = i + 1
      obj.procedimento = cadastros[i].procedimento
      obj.cbo = cadastros[i].cbo
      obj.quantidade = cadastros[i].quantidade
      data_pdf.push(obj)
    }
  }
  if (typeTable === 'meta') {
    headers_pdf = ['CATEGORIA', 'META', 'PRODUCÃO']
    var data_pdf = []
    for (let i = 0; i < cadastros.length; i++) {
      var obj = {}
      obj.categoria = cadastros[i].categoria
      obj.meta = cadastros[i].meta
      obj.quantidade = cadastros[i].quantidade
      data_pdf.push(obj)
    }
  }
  if (typeTable === 'professional') {
    headers_pdf = ['PROFISSIONAL', 'PRODUÇÃO', 'CATEGORIA']
    var data_pdf = []
    for (let i = 0; i < cadastros.length; i++) {
      var obj = {}
      obj.no_profissional = cadastros[i].no_prof
      obj.quantidade = cadastros[i].quantidade
      obj.categoria = cadastros[i].categoria
      data_pdf.push(obj)
    }
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      const dataSubscription = [
        {
          label: 'Unidade de saúde',
          value: no_us,
        },
        {
          label: 'Mês/ano',
          value: mes + '/' + ano,
        },
      ]

      if (typeTable === 'meta') {
        dataSubscription.push({
          label: 'CEO',
          value: typeCeo,
        })
      }

      verticalPosition = utils.methods.bodyPdf(
        doc,
        dataSubscription,
        verticalPosition
      )
      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (typeTable === 'meta') {
            if (data.row.raw[2] < data.row.raw[1]) {
              doc.setTextColor(194, 10, 16) // vermelho
            } else {
              doc.setTextColor(2, 99, 57) // verde
            }
            if (data.row.section === 'head') {
              doc.setTextColor(0, 0, 0)
            }
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export function printTableRow(item) {
  if (item.quantidade < item.meta) {
    return 'red'
  } else {
    return 'green'
  }
}
